import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import App from './App';

//Removes ripple effect from ISF Material UI Buttons
const theme = createTheme({
	props: {
		MuiButtonBase: {
			disableRipple: true // No more ripple, on the whole application 💣!
		}
	}
});
const route = window.location.pathname;
const isEs = route.indexOf('/es/') !== -1;
// const isEs = route.indexOf('/es/impact-featured-new-housing/') !== -1;

ReactDOM.render(
	//# rename
	<ThemeProvider theme={theme}>
		{/*# rename */}
		<Router basename={isEs ? '/es/impact/' : '/impact/'}>
		{/*<Router basename={isEs ? '/es/impact-isf/' : '/impact-isf/'}>*/}
			<App/>
		</Router>
	</ThemeProvider>,
	document.getElementById('root'),
);
